import { ref } from "vue"

export type MobileProfileDrawerPage = "edit" | "friends" | "status" | "settings"

// Lets any component open the mobile profile Drawer (MobileProfileDrawer.vue, mounted inside
// MobileBottomNav) straight on one of its pages — e.g. "Изменить профиль" in the user's own profile
// (UserProfileDialog.vue) goes to its "Редактировать профиль" page instead of the desktop /settings
// route. Module-scoped like useUserProfileDialog.ts: the Drawer owns its own open/page state and
// just consumes the request here, so nothing has to be threaded through the layout tree.
const requestedPage = ref<MobileProfileDrawerPage | null>(null)
let mountedDrawers = 0

export function useMobileProfileDrawer() {
  /** True while a profile Drawer is mounted (the bottom nav is shown), i.e. a request can be served. */
  function isAvailable() {
    return mountedDrawers > 0
  }

  function openPage(page: MobileProfileDrawerPage) {
    requestedPage.value = page
  }

  /** Called by MobileProfileDrawer.vue once it has acted on the request. */
  function consumeRequest() {
    requestedPage.value = null
  }

  function registerDrawer() {
    mountedDrawers++
    return () => { mountedDrawers-- }
  }

  return { requestedPage, isAvailable, openPage, consumeRequest, registerDrawer }
}
